<div class="loader">
	<div class="icon-loader"></div>
</div>
